// @ts-check
import PropTypes from 'prop-types';

import { lists } from 'services/inputTokens';
import { getFilter } from 'selectors/organisation';
import { setFilterGroup } from 'actions/organisation';
import { listsKeys } from 'components/Search/Filters/keys';
import { getResearcherText } from 'utils/constants';
import { tagRender } from 'components/common/TagRender';

import OrgFilterField from './OrgFilterField';
import OrgFilterSection from './OrgFilterSection';

const activeKeys = [listsKeys.lists.key, listsKeys.excludeLists.key];

const OrgListsSection = ({ organisationId, loading }) => (
  <OrgFilterSection
    organisationId={organisationId}
    icon='list'
    title={listsKeys.lists.sectionTitle}
    activeKeys={activeKeys}
  >
    <OrgFilterField
      filterType='selectIncludeExclude'
      mode='multiple'
      style={{ width: '100%' }}
      tagRender={tagRender}
      filterId={listsKeys.lists.key}
      placeholder='Included / Excluded'
      options={lists}
      helpText={`${getResearcherText({
        capitalize: true,
        isPlural: true,
      })} present in these lists will be included or excluded from results`}
      disabled={loading}
      remoteSearchOnClick
      optionProp={{ optionLabel: 'name', optionValue: 'id' }}
      organisationId={organisationId}
      setFilterGroup={setFilterGroup}
      getFilter={getFilter}
    />
  </OrgFilterSection>
);

OrgListsSection.propTypes = {
  organisationId: PropTypes.number.isRequired,
  loading: PropTypes.bool,
};

export default OrgListsSection;
